exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-shadow[data-v-615ad580]{text-shadow:0 0 4px #000}.btn.disabled[data-v-615ad580],.btn[disabled][data-v-615ad580]{cursor:not-allowed}.clickable[data-v-615ad580]{cursor:pointer}.unclickable[data-v-615ad580]{cursor:not-allowed}figure img[data-v-615ad580]{border-radius:1rem}figure small[data-v-615ad580]{position:absolute;bottom:-20px;left:0;right:0;text-align:center}@media screen and (min-width:991.98px){figure[data-v-615ad580]{margin-top:0}figure img[data-v-615ad580]{width:100%}}", ""]);

// exports
